export default __webpack_public_path__ + "static/media/spin_start.4b6206bf.mp3";